import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {
  CreateMixtureGroupExtras,
  isMixtureGroupWithCreatedMixture,
  MixtureGroupMetadata,
} from 'notebook/integrations/registry/MixtureGroupConstants';
import makeSimpleGroupActionFunction from 'notebook/notes/groups/action-functions/makeSimpleGroupActionFunction';
import {getMixtureGroupAdapter} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import legacyRunModal from 'ui-library/legacyRunModal';
import AddToWorklistModal from 'worklists/AddToWorklistModal';
import {WorklistType} from 'worklists/WorklistConstants';

const addMixtureGroupToWorklistActionFunction = makeSimpleGroupActionFunction<
  MixtureGroupMetadata,
  CreateMixtureGroupExtras
>({
  label: 'Add mixture to worklist',
  icon: 'worklist-add',
  onInvoke: ({noteLinkedGroup, evaluatedTableMap}) => {
    assert(
      isMixtureGroupWithCreatedMixture(noteLinkedGroup, evaluatedTableMap),
      'Cannot add to worklist when mixture id is missing'
    );
    const mixtureId = getMixtureGroupAdapter().getMixtureId(noteLinkedGroup, evaluatedTableMap)!;
    legacyRunModal(AddToWorklistModal, {
      ids: [mixtureId],
      worklistType: WorklistType.BIOENTITY,
      refreshOptions: {refreshRecentWorklists: true},
    });
  },
  getTooltip: ({noteLinkedGroup, evaluatedTableMap}) =>
    isMixtureGroupWithCreatedMixture(noteLinkedGroup, evaluatedTableMap)
      ? null
      : 'Register the mixture to add to worklist',
  getDisabled: ({noteLinkedGroup, evaluatedTableMap}) =>
    !isMixtureGroupWithCreatedMixture(noteLinkedGroup, evaluatedTableMap),
  getHidden: () => !BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS,
});

export default addMixtureGroupToWorklistActionFunction;
